var map = {
	"./audio/bongkar_notification.mp3": "44e7d",
	"./audio/dangerous_goods_notification.mp3": "5a58",
	"./audio/dangerous_goods_woodpacking_notification.mp3": "2bf5",
	"./audio/dangerous_goods_woodpacking_notification_en.mp3": "b698",
	"./audio/duplicate_scan_notification.wav": "984d",
	"./audio/error_notification.wav": "df24",
	"./audio/failed_notif_cargo.wav": "e4c3",
	"./audio/hal_notification.mp3": "34de0",
	"./audio/misroute_notification.mp3": "aadf",
	"./audio/pod_notification.mp3": "90c2",
	"./audio/rts_notification.mp3": "b57d",
	"./audio/success_notif_cargo.wav": "06f6",
	"./audio/success_notification.wav": "6bbb",
	"./audio/urgent_delivery_notification.mp3": "ceeb",
	"./audio/woodpacking_notification.mp3": "ef68",
	"./audio/woodpacking_notification_en.mp3": "1a8d",
	"./css/primevue.min.css": "a768",
	"./css/quill.core.css": "8c67",
	"./css/saga-blue.css": "fd45",
	"./css/style.css": "ba0e",
	"./css/tailwind.css": "d474",
	"./fonts": "9d63",
	"./fonts/": "9d63",
	"./fonts/index": "9d63",
	"./fonts/index.ts": "9d63",
	"./fonts/jsPDF/Inter": "7deb",
	"./fonts/jsPDF/Inter/": "7deb",
	"./fonts/jsPDF/Inter/Inter-Bold-normal": "6008",
	"./fonts/jsPDF/Inter/Inter-Bold-normal.js": "6008",
	"./fonts/jsPDF/Inter/Inter-ExtraBold-normal": "6a54",
	"./fonts/jsPDF/Inter/Inter-ExtraBold-normal.js": "6a54",
	"./fonts/jsPDF/Inter/Inter-Medium-normal": "87b9",
	"./fonts/jsPDF/Inter/Inter-Medium-normal.js": "87b9",
	"./fonts/jsPDF/Inter/Inter-SemiBold-normal": "cef0",
	"./fonts/jsPDF/Inter/Inter-SemiBold-normal.js": "cef0",
	"./fonts/jsPDF/Inter/index": "7deb",
	"./fonts/jsPDF/Inter/index.ts": "7deb",
	"./fonts/jsPDF/Montserrat": "1451",
	"./fonts/jsPDF/Montserrat/": "1451",
	"./fonts/jsPDF/Montserrat/Montserrat-Bold-italic": "8329",
	"./fonts/jsPDF/Montserrat/Montserrat-Bold-italic.js": "8329",
	"./fonts/jsPDF/Montserrat/Montserrat-Bold-normal": "335a",
	"./fonts/jsPDF/Montserrat/Montserrat-Bold-normal.js": "335a",
	"./fonts/jsPDF/Montserrat/Montserrat-ExtraBold-normal": "f900",
	"./fonts/jsPDF/Montserrat/Montserrat-ExtraBold-normal.js": "f900",
	"./fonts/jsPDF/Montserrat/Montserrat-Medium-normal": "ba72",
	"./fonts/jsPDF/Montserrat/Montserrat-Medium-normal.js": "ba72",
	"./fonts/jsPDF/Montserrat/Montserrat-Regular-normal": "3b5f",
	"./fonts/jsPDF/Montserrat/Montserrat-Regular-normal.js": "3b5f",
	"./fonts/jsPDF/Montserrat/Montserrat-SemiBold-normal": "a093",
	"./fonts/jsPDF/Montserrat/Montserrat-SemiBold-normal.js": "a093",
	"./fonts/jsPDF/Montserrat/index": "1451",
	"./fonts/jsPDF/Montserrat/index.ts": "1451",
	"./fonts/jsPDF/Poppins": "b7a9",
	"./fonts/jsPDF/Poppins/": "b7a9",
	"./fonts/jsPDF/Poppins/Poppins-Bold": "f634",
	"./fonts/jsPDF/Poppins/Poppins-Bold.js": "f634",
	"./fonts/jsPDF/Poppins/Poppins-Medium": "6752",
	"./fonts/jsPDF/Poppins/Poppins-Medium.js": "6752",
	"./fonts/jsPDF/Poppins/Poppins-Regular": "52cc",
	"./fonts/jsPDF/Poppins/Poppins-Regular.js": "52cc",
	"./fonts/jsPDF/Poppins/Poppins-SemiBold": "5d8c",
	"./fonts/jsPDF/Poppins/Poppins-SemiBold.js": "5d8c",
	"./fonts/jsPDF/Poppins/index": "b7a9",
	"./fonts/jsPDF/Poppins/index.ts": "b7a9",
	"./fonts/jsPDF/RobotoMono": "acbd",
	"./fonts/jsPDF/RobotoMono/": "acbd",
	"./fonts/jsPDF/RobotoMono/RobotoMono-Bold-normal": "3584",
	"./fonts/jsPDF/RobotoMono/RobotoMono-Bold-normal.js": "3584",
	"./fonts/jsPDF/RobotoMono/RobotoMono-Medium-normal": "9fa1",
	"./fonts/jsPDF/RobotoMono/RobotoMono-Medium-normal.js": "9fa1",
	"./fonts/jsPDF/RobotoMono/RobotoMono-SemiBold-normal": "cc50",
	"./fonts/jsPDF/RobotoMono/RobotoMono-SemiBold-normal.js": "cc50",
	"./fonts/jsPDF/RobotoMono/index": "acbd",
	"./fonts/jsPDF/RobotoMono/index.ts": "acbd",
	"./fonts/jsPDF/arabic": "aad9",
	"./fonts/jsPDF/arabic.ts": "aad9",
	"./fonts/jsPDF/bengali": "fcb3",
	"./fonts/jsPDF/bengali.ts": "fcb3",
	"./fonts/jsPDF/cambodian": "28f3",
	"./fonts/jsPDF/cambodian.ts": "28f3",
	"./fonts/jsPDF/chinese": "462c",
	"./fonts/jsPDF/chinese.ts": "462c",
	"./fonts/jsPDF/gujarati": "f395",
	"./fonts/jsPDF/gujarati.ts": "f395",
	"./fonts/jsPDF/japanese": "e7c7",
	"./fonts/jsPDF/japanese.ts": "e7c7",
	"./fonts/jsPDF/korean": "5e86",
	"./fonts/jsPDF/korean.ts": "5e86",
	"./fonts/jsPDF/module": "b592",
	"./fonts/jsPDF/module/": "b592",
	"./fonts/jsPDF/module/index": "b592",
	"./fonts/jsPDF/module/index.ts": "b592",
	"./fonts/jsPDF/nepali": "7a22",
	"./fonts/jsPDF/nepali.ts": "7a22",
	"./fonts/jsPDF/notosans": "b2e6",
	"./fonts/jsPDF/notosans.ts": "b2e6",
	"./fonts/jsPDF/punjabi": "9d66",
	"./fonts/jsPDF/punjabi.ts": "9d66",
	"./fonts/jsPDF/sinhala": "823b",
	"./fonts/jsPDF/sinhala.ts": "823b",
	"./fonts/jsPDF/tamil": "c328",
	"./fonts/jsPDF/tamil.ts": "c328",
	"./fonts/jsPDF/telugu": "ad04",
	"./fonts/jsPDF/telugu.ts": "ad04",
	"./fonts/jsPDF/thai": "e9d5",
	"./fonts/jsPDF/thai.ts": "e9d5",
	"./gif/genesis-loading.gif": "3cbf",
	"./images/Banner-Bonus-Komisi.webp": "9e86",
	"./images/Banner-Limit-Pinjaman.webp": "ecc1",
	"./images/CASHOUT-USER-PPOB.jpg": "87d5",
	"./images/Genesis-banner-bigpack-copy.jpg": "d61d",
	"./images/LP-BIGPACK-TACTICAL-GENESIS.jpg": "98bb",
	"./images/LP_JAGOPACK_Q1-2022_TACTICAL_Genesis.jpg": "26b9",
	"./images/LP_MBG_GENESIS.jpg": "d49a",
	"./images/OCBC-Banner.png": "1d67",
	"./images/QRIS-GENESIS-REVISI.jpg": "1301",
	"./images/banner-bisa-belanja-popup.webp": "5b8d",
	"./images/banner-bni-pop-up.webp": "338b",
	"./images/banner-bni.webp": "e1ac",
	"./images/banner-bosspack.png": "929b",
	"./images/banner-cashback.png": "46e4",
	"./images/banner-referral-belanja.webp": "a2e3",
	"./images/banner-referral-new.webp": "9f00",
	"./images/banner-referral.webp": "7050",
	"./images/banner.png": "f497",
	"./images/bca.png": "fd49",
	"./images/bg-detail-card.png": "3f3a",
	"./images/bg-feedback-rating.png": "13f5",
	"./images/bg-pattern-decorative.png": "8641",
	"./images/bg-qr-new-resi.png": "d191",
	"./images/bg-qr-section-resi.png": "6fba",
	"./images/black-cut.png": "4ef8",
	"./images/bni.png": "2dc8",
	"./images/bri.png": "32a9",
	"./images/cargo-dispute-photo-guide.png": "37d2",
	"./images/cod-logo.png": "4446",
	"./images/collectible-card-background.png": "60e8",
	"./images/collectible-card-error-image.png": "135d",
	"./images/cs_avatar.png": "d6c5",
	"./images/default-pdf.jpeg": "c5a0",
	"./images/dfod-logo.png": "69ae",
	"./images/dfod-logo.svg": "259e",
	"./images/dg-chips.png": "2fd6",
	"./images/dry.png": "211d",
	"./images/filetype-pdf-default-icon.png": "4761",
	"./images/frozen.png": "d58c",
	"./images/gamification-rtc-image.png": "5c4b",
	"./images/liolio-resi.png": "7e6e",
	"./images/logo-batik-air.png": "5c51",
	"./images/logo-client.png": "4278",
	"./images/logo-console.png": "4e8d",
	"./images/logo-genesis-2x.png": "b821",
	"./images/logo-genesis-3x.png": "d9bc",
	"./images/logo-genesis.png": "ae8f",
	"./images/logo-internal.png": "6001",
	"./images/logo-lion-air.png": "bc03",
	"./images/logo-lion-parcel-3x.png": "705c6",
	"./images/logo-lion-parcel-black.png": "5143",
	"./images/logo-lion-parcel.png": "b5e3",
	"./images/logo-pos.png": "6377",
	"./images/logo-priority-print.png": "8b87",
	"./images/logo-sub-console.png": "b7bb",
	"./images/logo-super-air-jet-short.png": "47b6",
	"./images/logo-super-jet-air.png": "8949",
	"./images/logo-vendor.png": "23c3",
	"./images/logo-wings-air.png": "3659",
	"./images/logo.png": "bda0",
	"./images/logo2.png": "8d9c",
	"./images/maps-coordinate.webp": "fae5",
	"./images/new-logo-lion-parcel-black.png": "99d6",
	"./images/pork.png": "1de7",
	"./images/primevue/color.png": "ebfe",
	"./images/primevue/hue.png": "5e23",
	"./images/prioritas.webp": "3b4a",
	"./images/progressive-commission/background-active.png": "a542",
	"./images/progressive-commission/background-inactive.png": "1f01",
	"./images/progressive-commission/bonus-komisi-illustration.png": "7f60",
	"./images/progressive-commission/money-active-1.png": "fce9",
	"./images/progressive-commission/money-inactive-2.png": "2c82",
	"./images/progressive-commission/money-inactive-3.png": "9efd",
	"./images/progressive-commission/money-inactive-4.png": "d8ed",
	"./images/progressive-commission/progress-commission.png": "8470",
	"./images/rhombus.jpg": "823a",
	"./images/summary-done-dex.png": "6e56",
	"./images/summary-match-dex.png": "007c",
	"./images/summary-not-match-dex.png": "70be",
	"./images/summary-total-dex.png": "a485",
	"./images/watermark-v2/bosspack.png": "bfe3",
	"./images/watermark-v2/bosspack_cod.png": "e6e8",
	"./images/watermark-v2/bosspack_cod_dg.png": "5c44",
	"./images/watermark-v2/bosspack_cod_dg_k.png": "29ca",
	"./images/watermark-v2/bosspack_cod_k.png": "ecd2",
	"./images/watermark-v2/bosspack_dfod.png": "b8a5",
	"./images/watermark-v2/bosspack_dfod_dg.png": "d822",
	"./images/watermark-v2/bosspack_dfod_dg_k.png": "ae8c",
	"./images/watermark-v2/bosspack_dfod_k.png": "d170",
	"./images/watermark-v2/bosspack_dg.png": "3805",
	"./images/watermark-v2/bosspack_dg_k.png": "850f",
	"./images/watermark-v2/bosspack_k.png": "844e",
	"./images/watermark-v2/cod.png": "beb7",
	"./images/watermark-v2/cod_dg.png": "f653",
	"./images/watermark-v2/cod_dg_k.png": "0698",
	"./images/watermark-v2/cod_k.png": "4a59",
	"./images/watermark-v2/dfod.png": "72e9",
	"./images/watermark-v2/dfod_dg.png": "6fc3",
	"./images/watermark-v2/dfod_dg_k.png": "175b",
	"./images/watermark-v2/dfod_k.png": "f531",
	"./images/watermark-v2/dg.png": "7a27",
	"./images/watermark-v2/dg_k.png": "7ef4",
	"./images/watermark-v2/interpackmaxi.png": "754c",
	"./images/watermark-v2/interpackmaxi_cod.png": "d757",
	"./images/watermark-v2/interpackmaxi_cod_dg.png": "b03b",
	"./images/watermark-v2/interpackmaxi_cod_dg_k.png": "3d19",
	"./images/watermark-v2/interpackmaxi_cod_k.png": "616d",
	"./images/watermark-v2/interpackmaxi_dfod.png": "0055",
	"./images/watermark-v2/interpackmaxi_dfod_dg.png": "a169",
	"./images/watermark-v2/interpackmaxi_dfod_dg_k.png": "c065",
	"./images/watermark-v2/interpackmaxi_dfod_k.png": "621b",
	"./images/watermark-v2/interpackmaxi_dg.png": "3da8",
	"./images/watermark-v2/interpackmaxi_dg_k.png": "2503",
	"./images/watermark-v2/interpackmaxi_k.png": "9ea0",
	"./images/watermark-v2/k.png": "931f",
	"./images/watermark-v2/prioritas.png": "1ace",
	"./images/watermark-v2/prioritas_bosspack.png": "ebb7",
	"./images/watermark-v2/prioritas_bosspack_cod.png": "e571",
	"./images/watermark-v2/prioritas_bosspack_cod_dg.png": "4273",
	"./images/watermark-v2/prioritas_bosspack_cod_dg_k.png": "ae28",
	"./images/watermark-v2/prioritas_bosspack_cod_k.png": "48d3",
	"./images/watermark-v2/prioritas_bosspack_dfod.png": "71d6",
	"./images/watermark-v2/prioritas_bosspack_dfod_dg.png": "4a55",
	"./images/watermark-v2/prioritas_bosspack_dfod_dg_k.png": "39aa",
	"./images/watermark-v2/prioritas_bosspack_dfod_k.png": "31ff",
	"./images/watermark-v2/prioritas_bosspack_dg.png": "22f2",
	"./images/watermark-v2/prioritas_bosspack_dg_k.png": "997d",
	"./images/watermark-v2/prioritas_bosspack_k.png": "9a73",
	"./images/watermark-v2/prioritas_cod.png": "e3b7",
	"./images/watermark-v2/prioritas_cod_dg.png": "db6e",
	"./images/watermark-v2/prioritas_cod_dg_k.png": "4cda",
	"./images/watermark-v2/prioritas_cod_k.png": "b22a",
	"./images/watermark-v2/prioritas_dfod.png": "16ce",
	"./images/watermark-v2/prioritas_dfod_dg.png": "5dfb",
	"./images/watermark-v2/prioritas_dfod_dg_k.png": "cf3f",
	"./images/watermark-v2/prioritas_dfod_k.png": "98db",
	"./images/watermark-v2/prioritas_dg.png": "40be",
	"./images/watermark-v2/prioritas_dg_k.png": "cd31",
	"./images/watermark-v2/prioritas_interpackmaxi_cod.png": "7363",
	"./images/watermark-v2/prioritas_interpackmaxi_cod_dg_k.png": "59e4",
	"./images/watermark-v2/prioritas_interpackmaxi_cod_k.png": "2c97",
	"./images/watermark-v2/prioritas_interpackmaxi_dfod_dg_k.png": "77c9",
	"./images/watermark-v2/prioritas_interpackmaxi_dfod_k.png": "bb99",
	"./images/watermark-v2/prioritas_interpackmaxi_dg_k.png": "2efe",
	"./images/watermark-v2/prioritas_interpackmaxi_k.png": "cdca",
	"./images/watermark-v2/prioritas_k.png": "3bb7",
	"./images/watermark-v2/prioritas_sameday.png": "ac4d",
	"./images/watermark-v2/prioritas_sameday_cod.png": "4db7",
	"./images/watermark-v2/prioritas_sameday_cod_dg.png": "dc6c",
	"./images/watermark-v2/prioritas_sameday_cod_dg_k.png": "6df4",
	"./images/watermark-v2/prioritas_sameday_cod_k.png": "3135e",
	"./images/watermark-v2/prioritas_sameday_dfod.png": "ef82",
	"./images/watermark-v2/prioritas_sameday_dfod_dg.png": "d5d5",
	"./images/watermark-v2/prioritas_sameday_dfod_dg_k.png": "f615",
	"./images/watermark-v2/prioritas_sameday_dfod_k.png": "fd7d",
	"./images/watermark-v2/prioritas_sameday_dg.png": "341b",
	"./images/watermark-v2/prioritas_sameday_dg_k.png": "f762",
	"./images/watermark-v2/prioritas_sameday_k.png": "3d77",
	"./images/watermark-v2/prioritas_vippack.png": "24df",
	"./images/watermark-v2/prioritas_vippack_cod.png": "0df5",
	"./images/watermark-v2/prioritas_vippack_cod_dg.png": "bf185",
	"./images/watermark-v2/prioritas_vippack_cod_dg_k.png": "43ec",
	"./images/watermark-v2/prioritas_vippack_cod_k.png": "d7a8",
	"./images/watermark-v2/prioritas_vippack_dfod.png": "6d9d",
	"./images/watermark-v2/prioritas_vippack_dfod_dg.png": "6fa2",
	"./images/watermark-v2/prioritas_vippack_dfod_dg_k.png": "496e",
	"./images/watermark-v2/prioritas_vippack_dfod_k.png": "d2db",
	"./images/watermark-v2/prioritas_vippack_dg.png": "9aae",
	"./images/watermark-v2/prioritas_vippack_dg_k.png": "40a9",
	"./images/watermark-v2/prioritas_vippack_k.png": "961f",
	"./images/watermark-v2/sameday.png": "c089",
	"./images/watermark-v2/sameday_cod.png": "84a0",
	"./images/watermark-v2/sameday_cod_dg.png": "2469",
	"./images/watermark-v2/sameday_cod_dg_k.png": "6618",
	"./images/watermark-v2/sameday_cod_k.png": "17a8",
	"./images/watermark-v2/sameday_dfod.png": "a650",
	"./images/watermark-v2/sameday_dfod_dg.png": "4f2c",
	"./images/watermark-v2/sameday_dfod_dg_k.png": "443d",
	"./images/watermark-v2/sameday_dfod_k.png": "86fc",
	"./images/watermark-v2/sameday_dg.png": "3b25",
	"./images/watermark-v2/sameday_dg_k.png": "ca70",
	"./images/watermark-v2/sameday_k.png": "ed26",
	"./images/watermark-v2/vippack.png": "be61",
	"./images/watermark-v2/vippack_cod.png": "cf87",
	"./images/watermark-v2/vippack_cod_dg.png": "c3ac",
	"./images/watermark-v2/vippack_cod_dg_k.png": "d4d1",
	"./images/watermark-v2/vippack_cod_k.png": "b45e",
	"./images/watermark-v2/vippack_dfod.png": "7ad9",
	"./images/watermark-v2/vippack_dfod_dg.png": "7961",
	"./images/watermark-v2/vippack_dfod_dg_k.png": "6775",
	"./images/watermark-v2/vippack_dfod_k.png": "706a",
	"./images/watermark-v2/vippack_dg.png": "faec",
	"./images/watermark-v2/vippack_dg_k.png": "8e37",
	"./images/watermark-v2/vippack_k.png": "8688",
	"./images/watermark/bg_cod.png": "ad24",
	"./images/watermark/bg_cod_pad.png": "1841",
	"./images/watermark/bg_dfod.png": "7404",
	"./images/watermark/bg_onepack.png": "ef4f",
	"./images/watermark/bg_onepack_cod.png": "c7dc",
	"./images/watermark/bg_onepack_dfod.png": "d7b0",
	"./images/watermark/bg_onepack_pad.png": "f532",
	"./images/watermark/bg_pad.png": "4a25",
	"./ocbc-illustration/lionparcel-ocbc-illustration.svg": "66fd2",
	"./ocbc-illustration/ocbc-illustration-1.svg": "ba0c",
	"./ocbc-illustration/ocbc-notification.svg": "29cb",
	"./string/thermal": "9cc0",
	"./string/thermal.ts": "9cc0",
	"./svg/+.svg": "52ce",
	"./svg/400-bad-request.svg": "6697",
	"./svg/BELUM_LUNAS_WATERMARK.svg": "fb17",
	"./svg/Bonus-Komisi-Icon-Collapse.svg": "7be3",
	"./svg/Ill_Badge_Action-Success.svg": "3d3e",
	"./svg/Ill_Badge_Login_Failed.svg": "4d36",
	"./svg/Ill_badge_input_manifest_gagal.svg": "2681",
	"./svg/LUNAS_WATERMARK.svg": "4cd7",
	"./svg/Ranking.svg": "a73b",
	"./svg/account-pin-lock.svg": "b072",
	"./svg/action_success.svg": "e925",
	"./svg/announce-fill.svg": "2972",
	"./svg/announce-hanging.svg": "4627",
	"./svg/announce.svg": "e004",
	"./svg/announcement.svg": "06bd",
	"./svg/are-you-sure.svg": "2b46",
	"./svg/arrow-circle-left-red.svg": "d526",
	"./svg/arrow-circle-left.svg": "ffbf",
	"./svg/arrow-circle-right-red.svg": "eb9a",
	"./svg/arrow-down-red.svg": "bb00",
	"./svg/arrow-left.svg": "b58b",
	"./svg/arrow-right-gray.svg": "593e",
	"./svg/arrow-right-line.svg": "1771",
	"./svg/arrow-right-white.svg": "d720",
	"./svg/arrow-up-green.svg": "2e22",
	"./svg/attachment-black.svg": "8583",
	"./svg/attachment-chat.svg": "ccd2",
	"./svg/attachment.svg": "3216",
	"./svg/awb-not-found.svg": "7f44",
	"./svg/awb-system-error.svg": "ca7b",
	"./svg/badge-batik-air.svg": "e172",
	"./svg/badge-confirmation-general.svg": "41e8",
	"./svg/badge-exit-confirmation.svg": "8f60",
	"./svg/badge-lion-air.svg": "50d0",
	"./svg/badge-success-task.svg": "3190",
	"./svg/badge-success.svg": "be65",
	"./svg/badge-super-jet-air.svg": "8a0c",
	"./svg/badge-warning-lg.svg": "a312",
	"./svg/badge-wings-air.svg": "ce0c",
	"./svg/bagging-list.svg": "dcfa",
	"./svg/bagging.svg": "8bf2",
	"./svg/balance-limit.svg": "e7cc",
	"./svg/ban-white.svg": "c22b",
	"./svg/ban.svg": "d3ba",
	"./svg/bank-account-setting.svg": "ab4b",
	"./svg/bank-red.svg": "922b",
	"./svg/banner-insurance-v2.svg": "6c08",
	"./svg/bg-client-circle-long.svg": "c011",
	"./svg/bg-client-circle.svg": "8f1b",
	"./svg/bg-dispute-summary.svg": "7ae0",
	"./svg/bg-dot-pattern-long.svg": "0fc9",
	"./svg/bg-dot-pattern.svg": "4420",
	"./svg/bg-header-before-sti-dest.svg": "9244",
	"./svg/bg-header-stt-overdue-del.svg": "b009",
	"./svg/bg-header-stt-should-del.svg": "e454",
	"./svg/bg-must-sti-booking.svg": "d3df",
	"./svg/bg-qr-code-hub.svg": "9d68",
	"./svg/bg-scan-shipment.svg": "5ae5",
	"./svg/bg-shipment-booked.svg": "34fb",
	"./svg/bg-sti-summary-stt.svg": "3f75",
	"./svg/bg-summary-card-yellow.svg": "9641",
	"./svg/bg-summary-card.svg": "af03f",
	"./svg/bg-summary-limit.svg": "74d2",
	"./svg/book.svg": "5140",
	"./svg/booking-client.svg": "ed68",
	"./svg/boss.svg": "8183",
	"./svg/box-bkd.svg": "cf66",
	"./svg/box-money-inactive.svg": "970e",
	"./svg/box-money.svg": "1378",
	"./svg/box_no_data.svg": "be2f",
	"./svg/bulk-booking.svg": "9bf5",
	"./svg/bulk.svg": "f21d",
	"./svg/calendar-outlined.svg": "d5da",
	"./svg/calendar.svg": "32f5",
	"./svg/cancel-success.svg": "8d8f",
	"./svg/cargo-unavailable.svg": "f09c",
	"./svg/cargo.svg": "5230",
	"./svg/cash.svg": "bba7",
	"./svg/cash_white.svg": "044e",
	"./svg/chart-bar-solid.svg": "77fc",
	"./svg/check-blue.svg": "4e50",
	"./svg/check-circle-border-green.svg": "b318",
	"./svg/check-circle-border-white.svg": "9752",
	"./svg/check-circle-border.svg": "8fa5",
	"./svg/check-circle-disable.svg": "d31d",
	"./svg/check-circle-gray.svg": "c181",
	"./svg/check-circle-red.svg": "4067",
	"./svg/check-circle.svg": "c894",
	"./svg/check-red.svg": "ae8d",
	"./svg/check-silver-circle.svg": "463b",
	"./svg/check-yellow.svg": "7f15",
	"./svg/check.svg": "7ddf",
	"./svg/check_circle.svg": "3351",
	"./svg/chevron-down-black.svg": "7c75",
	"./svg/chevron-down-bold-red.svg": "0285",
	"./svg/chevron-down-disable.svg": "deb3",
	"./svg/chevron-down-light.svg": "0e6c",
	"./svg/chevron-down-new.svg": "b592f",
	"./svg/chevron-down-red.svg": "432b",
	"./svg/chevron-down-white.svg": "0b19",
	"./svg/chevron-down.svg": "4227",
	"./svg/chevron-left-white.svg": "44fa",
	"./svg/chevron-left.svg": "4973",
	"./svg/chevron-next.svg": "2843",
	"./svg/chevron-prev.svg": "f839",
	"./svg/chevron-right-black.svg": "3fc2",
	"./svg/chevron-right-orange.svg": "cf7a",
	"./svg/chevron-right-red.svg": "2a1c",
	"./svg/chevron-right-white.svg": "8911",
	"./svg/chevron-right.svg": "53f6",
	"./svg/chevron-up-light.svg": "0a8c",
	"./svg/chevron-up-new.svg": "550e",
	"./svg/chevron-up-red.svg": "4fe3",
	"./svg/chevron-up-white.svg": "faaf",
	"./svg/chevron-up.svg": "4705",
	"./svg/chevron_circle.svg": "a970",
	"./svg/circle-error.svg": "9851",
	"./svg/circle-green.svg": "2b46a",
	"./svg/circle-red.svg": "477b",
	"./svg/circle.svg": "ba96",
	"./svg/client-ilustration.svg": "d91c",
	"./svg/client-list.svg": "6bb5",
	"./svg/clipboard-list.svg": "4ea3",
	"./svg/clock-exclamation.svg": "9adf",
	"./svg/clock-normal-red.svg": "d2c3",
	"./svg/clock-normal.svg": "b29e",
	"./svg/clock-orange.svg": "81bb",
	"./svg/clock-red.svg": "89c2",
	"./svg/clock-warning.svg": "5d77",
	"./svg/clock.svg": "baab",
	"./svg/clock2.svg": "fb27",
	"./svg/close-border-red.svg": "ec24",
	"./svg/close-circle.svg": "ebf1",
	"./svg/close-icon-notif.svg": "a01a",
	"./svg/close-white.svg": "b71d",
	"./svg/close_circle.svg": "681e",
	"./svg/close_white_icon.svg": "4175",
	"./svg/cloud-download.svg": "b6d7",
	"./svg/cloud-upload-sidebar.svg": "0d8f",
	"./svg/cloud-upload.svg": "b48f",
	"./svg/cod-badge-inactive.svg": "1691",
	"./svg/cod-badge.svg": "9fcb",
	"./svg/cod-label.svg": "1358",
	"./svg/cod-logo-2.svg": "6f4d",
	"./svg/cod-logo-3.svg": "8e24",
	"./svg/cod-red.svg": "8e80",
	"./svg/codrej-hanging.svg": "b62c",
	"./svg/coin-red.svg": "dfad",
	"./svg/coin-yellow.svg": "1039",
	"./svg/collectible-card-lp-back.svg": "8408",
	"./svg/collectible-card-total-background-large.svg": "3776",
	"./svg/collectible-card-total-background.svg": "06e6",
	"./svg/commissionConfig.svg": "f93b",
	"./svg/commissionSum.svg": "a285",
	"./svg/copy-clipboard.svg": "cd23",
	"./svg/courier-pickup.svg": "f01a",
	"./svg/cover-login.svg": "d68e",
	"./svg/create-faq.svg": "b929",
	"./svg/custom-process.svg": "cd77",
	"./svg/dashboard.svg": "02d8",
	"./svg/data-not-found.svg": "8d58",
	"./svg/deadline-expired.svg": "e6db",
	"./svg/del-hanging.svg": "ec6b",
	"./svg/delete-confirm.svg": "21349",
	"./svg/delete-success.svg": "0d44",
	"./svg/delete.svg": "c141",
	"./svg/delivery-proccess.svg": "3f18",
	"./svg/delivery.svg": "b79d",
	"./svg/dex-assesment/cpu-icon.svg": "2e22d",
	"./svg/dex-hanging.svg": "ad23",
	"./svg/dfod-badge-inactive.svg": "a3a5",
	"./svg/dfod-badge.svg": "c0df",
	"./svg/dfod-logo-2.svg": "4823",
	"./svg/dfod.svg": "fabc",
	"./svg/dispatch/dispatch_error.svg": "bfc1",
	"./svg/dispatch/dispatch_internet_error.svg": "f813",
	"./svg/dispatch/dispatch_server_error.svg": "616c",
	"./svg/dispatch/kondispatch_partially.svg": "e356",
	"./svg/dispatch/kondispatch_success.svg": "59ac",
	"./svg/dispatch/stldispatch_partially.svg": "b6af",
	"./svg/dispatch/stldispatch_success.svg": "bfb2",
	"./svg/dispute-background-ornament.svg": "680e",
	"./svg/document-add.svg": "e99e",
	"./svg/document-download-border.svg": "4e6d",
	"./svg/document-download-outline-grey.svg": "8163",
	"./svg/document-download-outline-white.svg": "f026",
	"./svg/document-download-outline.svg": "c95f",
	"./svg/document-download-red.svg": "cd7f",
	"./svg/document-download.svg": "5097",
	"./svg/document-text.svg": "d3e4",
	"./svg/dot-black.svg": "e60c",
	"./svg/download-gray.svg": "856c",
	"./svg/download-new-gray.svg": "4cd1",
	"./svg/download-new.svg": "ae2b",
	"./svg/download-white.svg": "14a1",
	"./svg/download.svg": "a5a4",
	"./svg/dry.svg": "0987",
	"./svg/duplicate.svg": "730a",
	"./svg/edit-button-remark.svg": "7587",
	"./svg/ellipse.svg": "c072",
	"./svg/emoji-chat.svg": "ef29",
	"./svg/empty-black.svg": "a156",
	"./svg/empty-flight-schedule-v2.svg": "e010",
	"./svg/empty-flight-schedule.svg": "9bc2",
	"./svg/empty-reverse-scan.svg": "c899",
	"./svg/empty.svg": "9f86",
	"./svg/error-internet.svg": "8043",
	"./svg/error-token-ngen.svg": "4ec0",
	"./svg/exchange -rate.svg": "aa8d2",
	"./svg/exclamation-circle-solid-gray.svg": "0b61",
	"./svg/exclamation-circle-solid-yellow.svg": "a6fc",
	"./svg/exclamation-circle-solid.svg": "678e",
	"./svg/exclamation-triangle-red.svg": "8a21",
	"./svg/exclamation-triangle.svg": "6350",
	"./svg/exclamation-yellow.svg": "ef59",
	"./svg/eye.svg": "d713",
	"./svg/eye_gray.svg": "7f7c",
	"./svg/failed-status.svg": "d77d",
	"./svg/file.svg": "0151",
	"./svg/flag/australia.svg": "2b16",
	"./svg/flag/austria.svg": "5b5b",
	"./svg/flag/bangladesh.svg": "3eb5",
	"./svg/flag/belgium.svg": "de31",
	"./svg/flag/brazil.svg": "9c95",
	"./svg/flag/brunei.svg": "274f",
	"./svg/flag/cambodia.svg": "e5ed",
	"./svg/flag/canada.svg": "12e8",
	"./svg/flag/china.svg": "af3f",
	"./svg/flag/costa_rica.svg": "b09f",
	"./svg/flag/denmark.svg": "c925",
	"./svg/flag/egypt.svg": "db0c",
	"./svg/flag/findland.svg": "68b9",
	"./svg/flag/france.svg": "2ced",
	"./svg/flag/germany.svg": "c075",
	"./svg/flag/greece.svg": "358a",
	"./svg/flag/hongkong.svg": "2828",
	"./svg/flag/india.svg": "34ef",
	"./svg/flag/indonesia.svg": "87a7",
	"./svg/flag/italy.svg": "7d4e",
	"./svg/flag/jepang.svg": "33be",
	"./svg/flag/kazakhstan.svg": "b679",
	"./svg/flag/korea.svg": "c3f3",
	"./svg/flag/kuwait.svg": "2b59",
	"./svg/flag/macau.svg": "c5dc",
	"./svg/flag/malaysia.svg": "1df3",
	"./svg/flag/mexico.svg": "6ff2c",
	"./svg/flag/monaco.svg": "7e94",
	"./svg/flag/morocco.svg": "b442",
	"./svg/flag/netherland.svg": "64ad",
	"./svg/flag/newzeland.svg": "6973",
	"./svg/flag/oman.svg": "c32a",
	"./svg/flag/pakistan.svg": "43d9",
	"./svg/flag/peru.svg": "8213",
	"./svg/flag/philippines.svg": "10c1",
	"./svg/flag/qatar.svg": "2b96",
	"./svg/flag/saudi_arabia.svg": "58fb",
	"./svg/flag/singapore.svg": "2afa",
	"./svg/flag/south_africa.svg": "ef54",
	"./svg/flag/spain.svg": "6b8e",
	"./svg/flag/sri_lanka.svg": "650b",
	"./svg/flag/sweden.svg": "f847",
	"./svg/flag/taiwan.svg": "547d",
	"./svg/flag/thailand.svg": "e2ea",
	"./svg/flag/timor-leste.svg": "f6b7",
	"./svg/flag/turkey.svg": "409c",
	"./svg/flag/uk.svg": "821e",
	"./svg/flag/uni_emirate_arab.svg": "464a",
	"./svg/flag/usa.svg": "0d82",
	"./svg/flag/venezuela.svg": "a6fe",
	"./svg/flag/vietnam.svg": "aa10",
	"./svg/flight-ID-batik-circle.svg": "56ba",
	"./svg/flight-IU-super-airjet-circle.svg": "0c28",
	"./svg/flight-IW-wings-circle.svg": "324c",
	"./svg/flight-JT-lion-circle.svg": "5afd",
	"./svg/flight-schedule-not-found.svg": "d37d",
	"./svg/flight_land.svg": "008d",
	"./svg/flight_takeoff.svg": "2f6b",
	"./svg/floating-booking.svg": "80ad",
	"./svg/frame-image.svg": "d637",
	"./svg/freeze.svg": "8401",
	"./svg/frozen.svg": "5a5a",
	"./svg/guide-photo-one.svg": "de40",
	"./svg/guide-photo-two.svg": "2ed0",
	"./svg/handover.svg": "dd59",
	"./svg/hanging-email.svg": "14c7",
	"./svg/help-desk.svg": "5310",
	"./svg/history-hanging.svg": "400d",
	"./svg/history-reconcile.svg": "1274",
	"./svg/hourglass-illustration.svg": "005d",
	"./svg/hourglass.svg": "0fdc",
	"./svg/hub.svg": "7aa3",
	"./svg/ic_arrow_range.svg": "ad28",
	"./svg/ic_checker_hanging.svg": "98fc",
	"./svg/ic_circle_green.svg": "4bbc",
	"./svg/ic_circle_red.svg": "a17b",
	"./svg/ic_circle_yellow.svg": "e8de",
	"./svg/ic_console_hanging.svg": "70cb",
	"./svg/ic_courier_hanging.svg": "c2ca",
	"./svg/ic_failed_unread.svg": "6b0e",
	"./svg/ic_followup_client.svg": "cecf",
	"./svg/ic_followup_console.svg": "d1f0",
	"./svg/ic_pic.svg": "67c4",
	"./svg/ic_pic_hanging.svg": "55f4",
	"./svg/ic_plane_hanging.svg": "ddbe",
	"./svg/ic_search_hanging.svg": "0785",
	"./svg/ic_truck_hanging.svg": "f604",
	"./svg/icon-area-scan.svg": "4cc8",
	"./svg/icon-arrow-left.svg": "0998",
	"./svg/icon-arrow-right.svg": "22ba",
	"./svg/icon-check-circle-red.svg": "6bee",
	"./svg/icon-check-white.svg": "ed64",
	"./svg/icon-close-black.svg": "66e1",
	"./svg/icon-dot.svg": "fefe",
	"./svg/icon-edit-dash.svg": "d1c8",
	"./svg/icon-excel.svg": "6720",
	"./svg/icon-exclamation-white.svg": "7713",
	"./svg/icon-play-video.svg": "9f4d",
	"./svg/icon-shield-white.svg": "5e56",
	"./svg/icon-stt.svg": "1b9d",
	"./svg/icon-task-white.svg": "ca08",
	"./svg/icon-time-white.svg": "effe",
	"./svg/icon-x-white.svg": "5b80",
	"./svg/icon_camera.svg": "d6bd",
	"./svg/icp-scan.svg": "2a56",
	"./svg/ics_close.svg": "3c62",
	"./svg/ics_download-template.svg": "e2b8",
	"./svg/ics_ellipse.svg": "2cae",
	"./svg/ics_f_announce.svg": "12d6",
	"./svg/ics_f_announce_green.svg": "aba5",
	"./svg/ics_f_announce_red.svg": "1904",
	"./svg/ics_f_announce_sdn.svg": "e110",
	"./svg/ics_f_announce_yellow.svg": "9c3c3",
	"./svg/ics_f_arrow-circle-right.svg": "193c",
	"./svg/ics_f_chat_warning.svg": "c3f7",
	"./svg/ics_f_check_circle.svg": "f292",
	"./svg/ics_f_check_circle_gray.svg": "977d",
	"./svg/ics_f_check_circle_green.svg": "74f8",
	"./svg/ics_f_clock2_orange.svg": "be6a",
	"./svg/ics_f_close_circle.svg": "5ad2",
	"./svg/ics_f_copy.svg": "6dba",
	"./svg/ics_f_cursor.svg": "0a27",
	"./svg/ics_f_info_circle.svg": "077e",
	"./svg/ics_f_info_circle_blue.svg": "a873",
	"./svg/ics_f_info_circle_dark_blue.svg": "2912",
	"./svg/ics_f_info_circle_gray.svg": "b17a",
	"./svg/ics_f_info_circle_yellow.svg": "9cf2",
	"./svg/ics_f_kg_circle.svg": "6891",
	"./svg/ics_f_location_pin.svg": "5ea3",
	"./svg/ics_f_min_circle.svg": "257d",
	"./svg/ics_f_plane_flight_line.svg": "6a3e",
	"./svg/ics_f_plus_circle.svg": "c4e6",
	"./svg/ics_f_save.svg": "a9e8",
	"./svg/ics_f_star.svg": "1832",
	"./svg/ics_f_thumb-bad-disabled.svg": "c176",
	"./svg/ics_f_thumb-bad-white.svg": "0079",
	"./svg/ics_f_thumb-bad.svg": "26bf",
	"./svg/ics_f_thumb-good-disabled.svg": "3d8f",
	"./svg/ics_f_thumb-good-white.svg": "81d7",
	"./svg/ics_f_thumb-good.svg": "a37d",
	"./svg/ics_f_thumb-neutral-disabled.svg": "5578",
	"./svg/ics_f_thumb-neutral-white.svg": "7a74",
	"./svg/ics_f_thumb-neutral.svg": "f9e0",
	"./svg/ics_f_trash.svg": "887d",
	"./svg/ics_f_warning_circle.svg": "56f5",
	"./svg/ics_f_warning_circle_red.svg": "952f",
	"./svg/ics_f_warning_triangles.svg": "cb5b",
	"./svg/ics_f_whatsapp.svg": "1076",
	"./svg/ics_o_active_client.svg": "4d45",
	"./svg/ics_o_arrow_down.svg": "286a",
	"./svg/ics_o_arrow_left.svg": "ef44",
	"./svg/ics_o_arrow_right.svg": "d714",
	"./svg/ics_o_arrow_right_red.svg": "e517",
	"./svg/ics_o_arrow_up.svg": "46ad",
	"./svg/ics_o_barcode.svg": "3055",
	"./svg/ics_o_boat.svg": "b948",
	"./svg/ics_o_booking.svg": "2d0a",
	"./svg/ics_o_booking_white.svg": "61c3",
	"./svg/ics_o_box.svg": "78a7",
	"./svg/ics_o_box_alt.svg": "ba2b",
	"./svg/ics_o_briefcase.svg": "c6eb",
	"./svg/ics_o_chevron_left.svg": "b979",
	"./svg/ics_o_chevron_right-red.svg": "e3de",
	"./svg/ics_o_chevron_sort.svg": "c091",
	"./svg/ics_o_chevron_sort_asc.svg": "283c",
	"./svg/ics_o_chevron_sort_desc.svg": "3f7e",
	"./svg/ics_o_clipboard.svg": "06ae",
	"./svg/ics_o_clock2.svg": "8369",
	"./svg/ics_o_clock_warning_red.svg": "48ee",
	"./svg/ics_o_close.svg": "2e4c",
	"./svg/ics_o_close_red.svg": "521d",
	"./svg/ics_o_cod_amount.svg": "002b",
	"./svg/ics_o_cod_rej.svg": "f654",
	"./svg/ics_o_commodity.svg": "af75",
	"./svg/ics_o_commodity_v2.svg": "5be5",
	"./svg/ics_o_commodity_v2_active.svg": "45ef",
	"./svg/ics_o_contactNote.svg": "6659",
	"./svg/ics_o_delivery_process.svg": "6390",
	"./svg/ics_o_delivery_received.svg": "1294",
	"./svg/ics_o_destination.svg": "6664",
	"./svg/ics_o_destination_active.svg": "4d66",
	"./svg/ics_o_dex_package.svg": "0d6f",
	"./svg/ics_o_document_gray.svg": "fee7",
	"./svg/ics_o_document_red.svg": "0944",
	"./svg/ics_o_download.svg": "3a64",
	"./svg/ics_o_download_2.svg": "02c8",
	"./svg/ics_o_download_circle.svg": "5364",
	"./svg/ics_o_download_circle_disabled.svg": "ab29",
	"./svg/ics_o_download_pdf.svg": "fc3c",
	"./svg/ics_o_download_pdf_struk.svg": "5cb7",
	"./svg/ics_o_download_png.svg": "a556",
	"./svg/ics_o_edit.svg": "1554",
	"./svg/ics_o_edit_dash_black.svg": "61da",
	"./svg/ics_o_edit_plus.svg": "94b5",
	"./svg/ics_o_edit_red.svg": "ab9f",
	"./svg/ics_o_eye.svg": "1b6d",
	"./svg/ics_o_eye_disabled.svg": "e596",
	"./svg/ics_o_eye_red.svg": "44c1",
	"./svg/ics_o_filter.svg": "10c6",
	"./svg/ics_o_filter_red.svg": "ce0f",
	"./svg/ics_o_flight-land.svg": "1c0bc",
	"./svg/ics_o_flight-takeoff.svg": "79d0",
	"./svg/ics_o_globe.svg": "590e",
	"./svg/ics_o_info_circle.svg": "91a4",
	"./svg/ics_o_info_circle_gray.svg": "bb29",
	"./svg/ics_o_kirim_tagihan.svg": "92f0",
	"./svg/ics_o_maps.svg": "8aab",
	"./svg/ics_o_mention.svg": "4a32",
	"./svg/ics_o_min_circle.svg": "5964",
	"./svg/ics_o_min_circle_active.svg": "9014",
	"./svg/ics_o_more.svg": "da79",
	"./svg/ics_o_multiple_file.svg": "7feb",
	"./svg/ics_o_on_delivery.svg": "279b",
	"./svg/ics_o_package-crrdon.svg": "cc53",
	"./svg/ics_o_package-crrotw.svg": "f690",
	"./svg/ics_o_package-crrpic.svg": "37f8",
	"./svg/ics_o_package_failed.svg": "c280",
	"./svg/ics_o_package_failed_crrdon.svg": "324f",
	"./svg/ics_o_package_failed_crrnfd.svg": "9326",
	"./svg/ics_o_package_failed_crrotw.svg": "171f",
	"./svg/ics_o_package_failed_crrpic.svg": "2317",
	"./svg/ics_o_person.svg": "b0c4",
	"./svg/ics_o_plane-booking-black.svg": "d50f",
	"./svg/ics_o_plus.svg": "19df",
	"./svg/ics_o_plus_gray.svg": "19610",
	"./svg/ics_o_pos.svg": "0bef",
	"./svg/ics_o_pos_active.svg": "c31a",
	"./svg/ics_o_print.svg": "2397",
	"./svg/ics_o_print_red.svg": "8316",
	"./svg/ics_o_profile.svg": "ec93",
	"./svg/ics_o_profile_active.svg": "d1cc",
	"./svg/ics_o_reload.svg": "8c5a",
	"./svg/ics_o_reload_gray.svg": "ce8d",
	"./svg/ics_o_save.svg": "cd9d",
	"./svg/ics_o_search.svg": "9b76",
	"./svg/ics_o_search_gray.svg": "2adc",
	"./svg/ics_o_services.svg": "0091",
	"./svg/ics_o_services_active.svg": "5843",
	"./svg/ics_o_shipping_service.svg": "bc52",
	"./svg/ics_o_shipping_service_active.svg": "94c0",
	"./svg/ics_o_sort.svg": "0e1f",
	"./svg/ics_o_sort_active.svg": "7a20",
	"./svg/ics_o_star.svg": "537c",
	"./svg/ics_o_sync.svg": "44f0",
	"./svg/ics_o_sync_white.svg": "f5a0",
	"./svg/ics_o_train-booking-black.svg": "3b98",
	"./svg/ics_o_trash.svg": "b3b6",
	"./svg/ics_o_truck-booking-black.svg": "c412",
	"./svg/ics_o_truck.svg": "dc1c",
	"./svg/ics_o_ubah_tagihan.svg": "f683",
	"./svg/ics_o_update_lunas.svg": "e11f",
	"./svg/ics_o_urgent_delivery.svg": "4746",
	"./svg/ics_o_wallet.svg": "e07d",
	"./svg/ics_o_warning_triangles.svg": "e560",
	"./svg/ics_o_whatsapp-background.svg": "bb47",
	"./svg/ill_approval_default.svg": "725c",
	"./svg/ill_badge_claim_confirmation.svg": "de75",
	"./svg/ill_badge_failed.svg": "6164",
	"./svg/ill_badge_print_lebel_pending.svg": "41e3",
	"./svg/ill_badge_profile_block_user.svg": "70e9",
	"./svg/ill_badge_profile_pin_lock.svg": "449e",
	"./svg/ill_badge_request_cod.svg": "9631",
	"./svg/ill_badge_request_pickup.svg": "a603",
	"./svg/ill_badge_success.svg": "aeba",
	"./svg/ill_badge_tariff_not_available.svg": "b3ca",
	"./svg/ill_calendar.svg": "0105",
	"./svg/ill_hanging_confirmation.svg": "ce01",
	"./svg/ill_pakket_full.svg": "c78d",
	"./svg/ill_pakket_full_green.svg": "9694",
	"./svg/ill_spot_ask_box.svg": "24be",
	"./svg/ill_spot_cancel_pickup.svg": "79d6",
	"./svg/ill_spot_da_out_of_range.svg": "a6a2",
	"./svg/ill_spot_embargo.svg": "10db",
	"./svg/ill_spot_failed_scan_stt.svg": "05ee",
	"./svg/ill_spot_info_tnc.svg": "f2ad",
	"./svg/ill_spot_miscellaneous.svg": "02bd",
	"./svg/ill_spot_search.svg": "2d8e",
	"./svg/ill_spot_search_2.svg": "fb2c",
	"./svg/ill_spot_success_scan_stt.svg": "b91c",
	"./svg/ill_spot_unavailable_location.svg": "9895",
	"./svg/ill_toko_unavailable.svg": "877a",
	"./svg/illustration_waiting_process.svg": "6664c",
	"./svg/image-modal-failed.svg": "0175",
	"./svg/image-modal-on-process.svg": "1498",
	"./svg/image-modal-success.svg": "b22c",
	"./svg/image-modal-warning.svg": "4c83",
	"./svg/in-hub-logo-partially.svg": "7d5e",
	"./svg/in_hub_logo.svg": "d30b",
	"./svg/inactive-account.svg": "896b",
	"./svg/inactive-location.svg": "8892",
	"./svg/info-red.svg": "0df7",
	"./svg/info-square.svg": "c7fd",
	"./svg/info-white.svg": "0029",
	"./svg/info.svg": "2659",
	"./svg/information-circle-green-1.svg": "b21f",
	"./svg/information-circle-red.svg": "1fb2",
	"./svg/information-circle-yellow.svg": "0de0",
	"./svg/information-circle.svg": "f437",
	"./svg/information.svg": "2627",
	"./svg/insight.svg": "01a2",
	"./svg/instant-booking-logo.svg": "50dc",
	"./svg/instant-booking.svg": "810c",
	"./svg/insurance-info.svg": "d6b1",
	"./svg/invisible.svg": "71c8",
	"./svg/invoice-gray.svg": "8f6e",
	"./svg/invoice.svg": "8ee6",
	"./svg/kejarcuan/active-1.svg": "ee2c",
	"./svg/kejarcuan/active-10.svg": "c742",
	"./svg/kejarcuan/active-11.svg": "1e0b",
	"./svg/kejarcuan/active-12.svg": "811a",
	"./svg/kejarcuan/active-13.svg": "6ee9",
	"./svg/kejarcuan/active-14.svg": "7fc6",
	"./svg/kejarcuan/active-15.svg": "8a35",
	"./svg/kejarcuan/active-16.svg": "6f32",
	"./svg/kejarcuan/active-17.svg": "bb81",
	"./svg/kejarcuan/active-18.svg": "e489",
	"./svg/kejarcuan/active-19.svg": "13d0",
	"./svg/kejarcuan/active-2.svg": "23f1",
	"./svg/kejarcuan/active-20.svg": "270e",
	"./svg/kejarcuan/active-21.svg": "506b",
	"./svg/kejarcuan/active-22.svg": "81c7",
	"./svg/kejarcuan/active-23.svg": "de93",
	"./svg/kejarcuan/active-24.svg": "068f",
	"./svg/kejarcuan/active-25.svg": "acf2",
	"./svg/kejarcuan/active-26.svg": "0bdd",
	"./svg/kejarcuan/active-27.svg": "88f6e",
	"./svg/kejarcuan/active-28.svg": "ee88",
	"./svg/kejarcuan/active-29.svg": "92e7",
	"./svg/kejarcuan/active-3.svg": "62e7",
	"./svg/kejarcuan/active-30.svg": "14b5",
	"./svg/kejarcuan/active-4.svg": "d3a60",
	"./svg/kejarcuan/active-5.svg": "fb71",
	"./svg/kejarcuan/active-6.svg": "6947",
	"./svg/kejarcuan/active-7.svg": "6fe7",
	"./svg/kejarcuan/active-8.svg": "60ca",
	"./svg/kejarcuan/active-9.svg": "2703",
	"./svg/kejarcuan/checklist-kejarcuan.svg": "bf64",
	"./svg/kejarcuan/inactive-1.svg": "59f6",
	"./svg/kejarcuan/inactive-10.svg": "2556",
	"./svg/kejarcuan/inactive-11.svg": "f0c6",
	"./svg/kejarcuan/inactive-12.svg": "499b",
	"./svg/kejarcuan/inactive-13.svg": "343f",
	"./svg/kejarcuan/inactive-14.svg": "d9f4",
	"./svg/kejarcuan/inactive-15.svg": "73d0",
	"./svg/kejarcuan/inactive-16.svg": "c962",
	"./svg/kejarcuan/inactive-17.svg": "25a5",
	"./svg/kejarcuan/inactive-18.svg": "0240",
	"./svg/kejarcuan/inactive-19.svg": "34ba",
	"./svg/kejarcuan/inactive-2.svg": "e857",
	"./svg/kejarcuan/inactive-20.svg": "b556",
	"./svg/kejarcuan/inactive-21.svg": "9adb",
	"./svg/kejarcuan/inactive-22.svg": "663d",
	"./svg/kejarcuan/inactive-23.svg": "9673",
	"./svg/kejarcuan/inactive-24.svg": "4516",
	"./svg/kejarcuan/inactive-25.svg": "336e",
	"./svg/kejarcuan/inactive-26.svg": "45f6",
	"./svg/kejarcuan/inactive-27.svg": "a6f31",
	"./svg/kejarcuan/inactive-28.svg": "dd81",
	"./svg/kejarcuan/inactive-29.svg": "9dff",
	"./svg/kejarcuan/inactive-3.svg": "b7f7",
	"./svg/kejarcuan/inactive-30.svg": "16d8",
	"./svg/kejarcuan/inactive-4.svg": "ae7b",
	"./svg/kejarcuan/inactive-5.svg": "5f0a",
	"./svg/kejarcuan/inactive-6.svg": "b457",
	"./svg/kejarcuan/inactive-7.svg": "c522",
	"./svg/kejarcuan/inactive-8.svg": "29e4",
	"./svg/kejarcuan/inactive-9.svg": "7639",
	"./svg/kejarcuan/kejarcuan-logo.svg": "f736",
	"./svg/kulioner-must-buy.svg": "ef56",
	"./svg/kulioner-not-buy.svg": "1604",
	"./svg/kulioner-was-buy.svg": "8fb31",
	"./svg/kurir-hanging.svg": "ac09",
	"./svg/leaving-page-illustration.svg": "e1be",
	"./svg/leg-management.svg": "dff5",
	"./svg/level/bronze.svg": "2ceb",
	"./svg/level/diamond.svg": "1559",
	"./svg/level/gold.svg": "7e59",
	"./svg/level/platinum.svg": "5c32",
	"./svg/level/silver.svg": "ad52",
	"./svg/library.svg": "081e",
	"./svg/line-horizontal.svg": "7427",
	"./svg/lion-parcel-red.svg": "f932",
	"./svg/list-doc.svg": "2881",
	"./svg/loading-gray.svg": "ebfc",
	"./svg/location-pin.svg": "bc51",
	"./svg/lock-white.svg": "c714",
	"./svg/login-approval/empty-history.svg": "acaa",
	"./svg/login-approval/login-rejected.png": "c8b9",
	"./svg/login-approval/logo-approval.svg": "1894",
	"./svg/login-failed.svg": "673e",
	"./svg/login-img.svg": "13cb",
	"./svg/logo-client.svg": "a390",
	"./svg/logo-console.svg": "5358",
	"./svg/logo-general.svg": "e736",
	"./svg/logo-genesis-new.svg": "6c18",
	"./svg/logo-genesis-with-text.svg": "8ddf",
	"./svg/logo-genesis.svg": "8cec",
	"./svg/logo-internal.svg": "5b0b",
	"./svg/logo-lion-parcel-red.svg": "b9a5",
	"./svg/logo-lion-parcel.svg": "880f",
	"./svg/logo-lion.svg": "270b",
	"./svg/logo-pos.svg": "d4f4",
	"./svg/logo-sender.svg": "3364",
	"./svg/logo-sub-console.svg": "324d",
	"./svg/logo-vendor.svg": "96d7",
	"./svg/logo.svg": "34cd",
	"./svg/logout-image.svg": "39f0",
	"./svg/logout-red.svg": "0a73",
	"./svg/logout.svg": "d5fc",
	"./svg/mail.svg": "c596a",
	"./svg/manual-deduct.svg": "cdda",
	"./svg/max-koli-plane.svg": "2493",
	"./svg/minipack-badge.svg": "7cbc",
	"./svg/more-data-table.svg": "bd75",
	"./svg/multi-people.svg": "fb37",
	"./svg/new-badge-failed.svg": "5b36",
	"./svg/new-cod-disabled.svg": "35ea",
	"./svg/new-cod.svg": "c611",
	"./svg/new-dfod-2.svg": "a57b",
	"./svg/new-dfod-disabled.svg": "10da",
	"./svg/new-dfod.svg": "0075",
	"./svg/new-message.svg": "96a1",
	"./svg/next-arrow-red.svg": "9a3b",
	"./svg/next-arrow.svg": "f7c4",
	"./svg/no-address.svg": "bd38",
	"./svg/no-data-incoming-outgoing.svg": "adc6",
	"./svg/no-data-list.svg": "f1ab",
	"./svg/no-internet.svg": "dc90",
	"./svg/no-notif.svg": "0bc5",
	"./svg/noData_empty.svg": "d119",
	"./svg/noData_empty_new.svg": "5798",
	"./svg/noData_filter.svg": "93e5",
	"./svg/not-found.svg": "f37a",
	"./svg/notebook-slash-gray.svg": "f290",
	"./svg/notes-reconcile.svg": "ab0fd",
	"./svg/notification.svg": "f44b",
	"./svg/on-process-booking-cargo.svg": "0ea4",
	"./svg/option-gray.svg": "b891",
	"./svg/option.svg": "56b6",
	"./svg/ornament.svg": "7757",
	"./svg/out-hub-logo-partially.svg": "fee4",
	"./svg/out_hub_logo.svg": "129c",
	"./svg/paper-clip-pencil.svg": "11a7",
	"./svg/partially-status.svg": "9c56",
	"./svg/partially.svg": "2b2a",
	"./svg/password_saved.svg": "8c40",
	"./svg/payment-button.svg": "4d25",
	"./svg/payment.svg": "10fa",
	"./svg/payment/example-qr.svg": "48f9",
	"./svg/payment/logo-bca_qris-active.svg": "3d01",
	"./svg/payment/logo-bca_qris-inactive.svg": "2a00",
	"./svg/payment/logo-bca_qris2-active.svg": "ab0f",
	"./svg/payment/logo-gopay_qris-active.svg": "79ce",
	"./svg/payment/logo-gopay_qris-inactive.svg": "4535",
	"./svg/payment/logo-linkaja_qris-active.svg": "26d2",
	"./svg/payment/logo-linkaja_qris-inactive.svg": "c844",
	"./svg/payment/logo-ovo_qris-active.svg": "06a6",
	"./svg/payment/logo-ovo_qris-inactive.svg": "ad1d",
	"./svg/payment/logo-ovo_qris2-active.svg": "88f6",
	"./svg/payment/logo-shopeepay_qris-active.svg": "3320",
	"./svg/payment/logo-shopeepay_qris-inactive.svg": "b404",
	"./svg/payment/payment-cash-illustration.svg": "d3c4",
	"./svg/payment/payment-failed-illustration.svg": "9f244",
	"./svg/payment/payment-success-illustration.svg": "1659",
	"./svg/payment/payment-timeout-illustration.svg": "0e2d",
	"./svg/payment/success-booking-illustration.svg": "e8f2",
	"./svg/pencil-alt-disable.svg": "da8f",
	"./svg/pencil-alt-grey.svg": "ccb6",
	"./svg/pencil-alt-white.svg": "b142",
	"./svg/pencil-alt.svg": "7579",
	"./svg/pickup-agent-hub.svg": "08a1",
	"./svg/pickup-total-pickup.svg": "5a99",
	"./svg/pickup-total-request.svg": "d7f7",
	"./svg/pin-location.svg": "30ed",
	"./svg/plane-booking-active.svg": "43a7",
	"./svg/plane-booking-gray.svg": "8db2",
	"./svg/plane-booking.svg": "8a57",
	"./svg/plane-hanging.svg": "2af1",
	"./svg/plane-icon-black.svg": "1af4",
	"./svg/plane-icon.svg": "26c6",
	"./svg/plane-transit.svg": "f7e6",
	"./svg/play-mov.svg": "a2d5",
	"./svg/play-video.svg": "11f8",
	"./svg/plus-active.svg": "fd8f",
	"./svg/plus-circle-red.svg": "3c7e",
	"./svg/plus-circle-white.svg": "c253",
	"./svg/plus-o.svg": "4997",
	"./svg/plus-solid-red.svg": "63b3",
	"./svg/plus-solid.svg": "10fd",
	"./svg/plus-square.svg": "1c1a",
	"./svg/plus-white.svg": "c5a1",
	"./svg/plus.svg": "1d5d",
	"./svg/pod-dex.svg": "e4e4",
	"./svg/pork.svg": "11d5",
	"./svg/pos-leaderboard-badge-rank-1.svg": "b2ed",
	"./svg/pos-leaderboard-badge-rank-2.svg": "bc0e",
	"./svg/pos-leaderboard-badge-rank-3.svg": "afa6",
	"./svg/pos-leaderboard-badge-rank-4.svg": "7d48",
	"./svg/pos-leaderboard-badge-rank-5.svg": "3360",
	"./svg/ppob-ilustration-1.svg": "a07a",
	"./svg/ppob-ilustration-2.svg": "f8fa",
	"./svg/prev-arrow-red.svg": "8004",
	"./svg/prev-arrow.svg": "f468",
	"./svg/pricing.svg": "a120",
	"./svg/print-label-pending.svg": "faeb",
	"./svg/print-pti.svg": "8b6f",
	"./svg/print-sptj.svg": "0921",
	"./svg/print-summary.svg": "a847",
	"./svg/printer-black.svg": "a5c0",
	"./svg/printer-gray.svg": "e285",
	"./svg/printer-red.svg": "2639",
	"./svg/printer-white.svg": "2b06",
	"./svg/printer.svg": "d263",
	"./svg/product-logo-v3/bigpack-active.svg": "12bf",
	"./svg/product-logo-v3/bigpack-inactive.svg": "545e",
	"./svg/product-logo-v3/bigpackfast-active.svg": "02cd",
	"./svg/product-logo-v3/bigpackfast-inactive.svg": "ca0e",
	"./svg/product-logo-v3/bosspack-active.svg": "36b0",
	"./svg/product-logo-v3/bosspack-inactive.svg": "8915",
	"./svg/product-logo-v3/interpack-active.svg": "60c6",
	"./svg/product-logo-v3/interpack-inactive.svg": "fc9f",
	"./svg/product-logo-v3/interpackmaxi-active.svg": "accb",
	"./svg/product-logo-v3/interpackmaxi-inactive.svg": "7ec6",
	"./svg/product-logo-v3/jagopack-active.svg": "ecef",
	"./svg/product-logo-v3/jagopack-inactive.svg": "f59f",
	"./svg/product-logo-v3/jumbopack-active.svg": "dac3",
	"./svg/product-logo-v3/jumbopack-inactive.svg": "e4e3",
	"./svg/product-logo-v3/minipack-active.svg": "14ef",
	"./svg/product-logo-v3/minipack-inactive.svg": "1d97",
	"./svg/product-logo-v3/onepack-active.svg": "07a1",
	"./svg/product-logo-v3/onepack-inactive.svg": "73d7",
	"./svg/product-logo-v3/otopack150-active.svg": "7f35",
	"./svg/product-logo-v3/otopack150-inactive.svg": "0b7f",
	"./svg/product-logo-v3/otopack250-active.svg": "6fa8",
	"./svg/product-logo-v3/otopack250-inactive.svg": "3be4",
	"./svg/product-logo-v3/regpack-active.svg": "b519",
	"./svg/product-logo-v3/regpack-inactive.svg": "85dd",
	"./svg/product-logo-v3/sameday-active.svg": "37d3",
	"./svg/product-logo-v3/sameday-inactive.svg": "548f",
	"./svg/product-logo-v3/vippack-active.svg": "cb9d",
	"./svg/product-logo-v3/vippack-inactive.svg": "a7f9",
	"./svg/product-logo/bigpack-active.svg": "ad9d",
	"./svg/product-logo/bigpack-inactive.svg": "c722",
	"./svg/product-logo/bigpackfast-active.svg": "2513",
	"./svg/product-logo/bigpackfast-inactive.svg": "192f",
	"./svg/product-logo/bosspack-active.svg": "78e2",
	"./svg/product-logo/bosspack-inactive.svg": "fa8d",
	"./svg/product-logo/interpack-active.svg": "a888",
	"./svg/product-logo/interpack-inactive.svg": "08ea",
	"./svg/product-logo/interpackmaxi-active.svg": "c9de",
	"./svg/product-logo/interpackmaxi-inactive.svg": "efdb",
	"./svg/product-logo/jagopack-active.svg": "8e72",
	"./svg/product-logo/jagopack-inactive.svg": "2b0e",
	"./svg/product-logo/jumbopack-active.svg": "1b90",
	"./svg/product-logo/jumbopack-inactive.svg": "7615",
	"./svg/product-logo/jumbopackh2h-active.svg": "f334",
	"./svg/product-logo/jumbopackh2h-inactive.svg": "854b",
	"./svg/product-logo/minipack-active.svg": "7198",
	"./svg/product-logo/minipack-inactive.svg": "6a24",
	"./svg/product-logo/onepack-active.svg": "9674",
	"./svg/product-logo/onepack-inactive.svg": "9e63",
	"./svg/product-logo/otopack-150-active.svg": "acf7",
	"./svg/product-logo/otopack-150-inactive.svg": "9eaa",
	"./svg/product-logo/otopack-250-active.svg": "1ccc",
	"./svg/product-logo/otopack-250-inactive.svg": "5211",
	"./svg/product-logo/otopack150-active.svg": "45cf",
	"./svg/product-logo/otopack150-inactive.svg": "f87f",
	"./svg/product-logo/otopack250-active.svg": "76e3",
	"./svg/product-logo/otopack250-inactive.svg": "4b13",
	"./svg/product-logo/regpack-active.svg": "9ff9",
	"./svg/product-logo/regpack-inactive.svg": "9a54",
	"./svg/product-logo/sameday-active.svg": "25ad",
	"./svg/product-logo/sameday-inactive.svg": "320d",
	"./svg/product-logo/vippack-active.svg": "6219",
	"./svg/product-logo/vippack-inactive.svg": "48d5",
	"./svg/product-type/bigpack-badge.svg": "63da",
	"./svg/product-type/bigpackfast-badge.svg": "ffb0",
	"./svg/product-type/bosspack-badge.svg": "e298",
	"./svg/product-type/interpack-badge.svg": "495a",
	"./svg/product-type/interpackmaxi-badge.svg": "c947",
	"./svg/product-type/jagopack-badge.svg": "4e3a",
	"./svg/product-type/jumbopack-badge.svg": "e07fd",
	"./svg/product-type/jumbopackh2h-badge.svg": "b14f",
	"./svg/product-type/minipack-badge.svg": "cedc",
	"./svg/product-type/onepack-badge.svg": "f8b2",
	"./svg/product-type/otopack150-badge.svg": "1553",
	"./svg/product-type/otopack250-badge.svg": "43c1",
	"./svg/product-type/regpack-badge.svg": "7acd",
	"./svg/product-type/sameday-badge.svg": "2080",
	"./svg/product-type/vippack-badge.svg": "9d64",
	"./svg/product.svg": "42bf",
	"./svg/profile-login.svg": "61fa",
	"./svg/progressive-commission.svg": "5e32",
	"./svg/qrcode.svg": "d4aa",
	"./svg/radio-button-disable.svg": "8601",
	"./svg/radio-button-filled.svg": "05e9",
	"./svg/radio-button-success.svg": "b513",
	"./svg/rebooking.svg": "39a6",
	"./svg/red-border-check.svg": "6ae5",
	"./svg/referral/banner-referal.svg": "9f9d",
	"./svg/referral/banner-referral-new.png": "2bb7",
	"./svg/referral/referral-register-icon.svg": "2ca7",
	"./svg/refresh-disable.svg": "4763",
	"./svg/refresh-green.svg": "db1d",
	"./svg/refresh-white.svg": "61d2",
	"./svg/refresh.svg": "8129",
	"./svg/rejected.svg": "10ba",
	"./svg/reload-grey.svg": "aaca",
	"./svg/reload-red.svg": "02e4",
	"./svg/reload-white.svg": "102c",
	"./svg/report-red.svg": "c2aa",
	"./svg/report.svg": "5658",
	"./svg/roleManagement.svg": "15d5",
	"./svg/route.svg": "3fd6",
	"./svg/rtc-background-process.svg": "099a",
	"./svg/scan-cargoV2-badges/empty-state.svg": "d908",
	"./svg/scan-cargoV2-badges/error.svg": "5c1d",
	"./svg/scan-cargoV2-badges/success-with-bosspack.svg": "964d",
	"./svg/scan-cargoV2-badges/success-with-dg-bosspack.svg": "a720",
	"./svg/scan-cargoV2-badges/success-with-dg-woodpacking-bosspack-en.svg": "34eb",
	"./svg/scan-cargoV2-badges/success-with-dg-woodpacking-bosspack.svg": "0673",
	"./svg/scan-cargoV2-badges/success-with-dg-woodpacking-en.svg": "7933",
	"./svg/scan-cargoV2-badges/success-with-dg-woodpacking.svg": "bbcd",
	"./svg/scan-cargoV2-badges/success-with-dg.svg": "77c78",
	"./svg/scan-cargoV2-badges/success-with-woodpacking-bosspack-en.svg": "bb4c",
	"./svg/scan-cargoV2-badges/success-with-woodpacking-bosspack.svg": "39b1",
	"./svg/scan-cargoV2-badges/success-with-woodpacking-en.svg": "9cf1",
	"./svg/scan-cargoV2-badges/success-with-woodpacking.svg": "6007",
	"./svg/scan-cargoV2-badges/success.svg": "581b",
	"./svg/scan-flags/bagging_ilust_dg_woodpacking.svg": "3d64",
	"./svg/scan-flags/bagging_ilust_dg_woodpacking_en.svg": "3af8",
	"./svg/scan-flags/bagging_woodpacking.svg": "5cc6",
	"./svg/scan-flags/bagging_woodpacking_en.svg": "ee29",
	"./svg/scan-flags/cargo_dg_woodpacking_example.svg": "99fb",
	"./svg/scan-flags/sti-dest_dg_woodpacking.svg": "cbae",
	"./svg/scan-flags/sti_dg_woodpacking.svg": "518f",
	"./svg/scan-hanging.svg": "4cbc",
	"./svg/scan-qrcode.svg": "f3bf",
	"./svg/search.svg": "8b16",
	"./svg/send-chat-active.svg": "8136",
	"./svg/send-chat.svg": "5007",
	"./svg/sended.svg": "2c34",
	"./svg/separtor_chevron.svg": "ee80",
	"./svg/server-error.svg": "b322",
	"./svg/setor-harian-kurir-red.svg": "6b1a",
	"./svg/setor-harian-kurir.svg": "dd95",
	"./svg/shipment.svg": "7924",
	"./svg/shortcut-booking-client.svg": "2ea8",
	"./svg/shortcut-booking-ilustration.svg": "2600",
	"./svg/shortcut-booking-instant.svg": "e9e44",
	"./svg/shortcut-booking-manual.svg": "56b7",
	"./svg/shortcut-booking-shipment.svg": "68d7",
	"./svg/shortland-hanging.svg": "4bc3",
	"./svg/shortland.svg": "0a94",
	"./svg/snackbar-success.svg": "2efb",
	"./svg/sort-filter-gray.svg": "3736",
	"./svg/sort-filter-red.svg": "72d5",
	"./svg/sort-filter.svg": "eed7",
	"./svg/sort.svg": "bfd7",
	"./svg/sparkles.svg": "5b11",
	"./svg/spot-404.svg": "3bde",
	"./svg/status-failed.svg": "2689",
	"./svg/status-request.svg": "839a",
	"./svg/status-success.svg": "ef39",
	"./svg/sti-active.svg": "00bf",
	"./svg/sti-dest-active.svg": "500f",
	"./svg/sti-dest-hanging.svg": "a03b",
	"./svg/sti-dest-sc-active.svg": "a7b5",
	"./svg/sti-dest-sc.svg": "55dc",
	"./svg/sti-dest-transit/dangerous-goods.svg": "be9b",
	"./svg/sti-dest-transit/woodpacking-en.svg": "ea40",
	"./svg/sti-dest-transit/woodpacking.svg": "147b",
	"./svg/sti-dest.svg": "5c54",
	"./svg/sti-reverse-scan/duplicate-scan-label-en.svg": "6c75",
	"./svg/sti-reverse-scan/duplicate-scan-label.svg": "1666",
	"./svg/sti-reverse-scan/icon-bag-en.svg": "d2a7",
	"./svg/sti-reverse-scan/icon-bag-note-en.svg": "8c8a",
	"./svg/sti-reverse-scan/icon-bag-note.svg": "b880",
	"./svg/sti-reverse-scan/icon-bag.svg": "62e6",
	"./svg/sti-reverse-scan/icon-dangerous-goods-text.svg": "67be",
	"./svg/sti-reverse-scan/icon-dangerous-goods-woodpacking-text-en.svg": "1de4",
	"./svg/sti-reverse-scan/icon-dangerous-goods-woodpacking-text.svg": "6dff",
	"./svg/sti-reverse-scan/icon-dangerous-goods.svg": "c961",
	"./svg/sti-reverse-scan/icon-hal-en.svg": "1cf7",
	"./svg/sti-reverse-scan/icon-hal.svg": "e8b9",
	"./svg/sti-reverse-scan/icon-pod-en.svg": "712a",
	"./svg/sti-reverse-scan/icon-pod.svg": "f5de",
	"./svg/sti-reverse-scan/icon-relabel-en.svg": "c435",
	"./svg/sti-reverse-scan/icon-relabel.svg": "64e8",
	"./svg/sti-reverse-scan/icon-rts-en.svg": "0c63",
	"./svg/sti-reverse-scan/icon-rts.svg": "94f2e",
	"./svg/sti-reverse-scan/icon-scan-failed-en.svg": "d814",
	"./svg/sti-reverse-scan/icon-scan-failed-my.svg": "dfc1",
	"./svg/sti-reverse-scan/icon-scan-failed-underpaid-en.svg": "2307",
	"./svg/sti-reverse-scan/icon-scan-failed-underpaid.svg": "2092",
	"./svg/sti-reverse-scan/icon-scan-failed.svg": "c8b2",
	"./svg/sti-reverse-scan/icon-sti-dest-relabel.svg": "c38f",
	"./svg/sti-reverse-scan/icon-sti-dest.svg": "a9b1",
	"./svg/sti-reverse-scan/icon-sti-sti-dest-bag.svg": "9869",
	"./svg/sti-reverse-scan/icon-sti-sti-dest-hal.svg": "3a93",
	"./svg/sti-reverse-scan/icon-sti-sti-dest-pod-overdue.svg": "7b1c",
	"./svg/sti-reverse-scan/icon-sti-sti-dest-pod-today.svg": "d1fd",
	"./svg/sti-reverse-scan/icon-sti-sti-dest-pod-urgent-delivery.svg": "1b39",
	"./svg/sti-reverse-scan/icon-sti-sti-dest-rts-overdue.svg": "96f4",
	"./svg/sti-reverse-scan/icon-sti-sti-dest-rts-today.svg": "88a0",
	"./svg/sti-reverse-scan/icon-sti-sti-dest-rts-tomorrow.svg": "b86ea",
	"./svg/sti-reverse-scan/icon-sti.svg": "d0e1",
	"./svg/sti-reverse-scan/icon-taken-by-recipient-en.svg": "49d2",
	"./svg/sti-reverse-scan/icon-taken-by-recipient.svg": "6748",
	"./svg/sti-reverse-scan/icon-woodpacking-en.svg": "f020",
	"./svg/sti-reverse-scan/icon-woodpacking.svg": "9cdb",
	"./svg/sti-reverse-scan/scan-empty-state.svg": "c85e",
	"./svg/sti-sc-active.svg": "0b2f",
	"./svg/sti-sc-gray.svg": "4aa3",
	"./svg/sti-sc-reverse-scan/icon-sti-sc.svg": "9311",
	"./svg/sti-sc.svg": "d376",
	"./svg/sti.svg": "9994",
	"./svg/stop-program.svg": "4137",
	"./svg/stt-del-active.svg": "fc6d",
	"./svg/stt-del.svg": "928b",
	"./svg/stt-dex-active.svg": "3ea2",
	"./svg/stt-dex.svg": "f1ac",
	"./svg/stt-not-valid.svg": "0eed",
	"./svg/success-status.svg": "f473",
	"./svg/success.svg": "a868",
	"./svg/summary-dex-complete.svg": "4553",
	"./svg/summary-dex-not-match.svg": "e5ef",
	"./svg/summary-dispute-accept.svg": "5498",
	"./svg/summary-dispute-approved.svg": "27ee",
	"./svg/summary-dispute-rejected.svg": "0ec9",
	"./svg/summary-dispute-requested.svg": "5d13",
	"./svg/summary-total-dex.svg": "9f97",
	"./svg/support-pos-favourite.svg": "5638",
	"./svg/sync-hanging.svg": "da05",
	"./svg/sync-paket.svg": "5dc9",
	"./svg/system-error-console-current-stt.svg": "5a19",
	"./svg/texhnicalConfig.svg": "918a",
	"./svg/thumb_down.svg": "6ce5",
	"./svg/thumb_up.svg": "6aed",
	"./svg/thumb_up_&_thumb_down.svg": "ae2e",
	"./svg/thumb_up_&_thumb_down_disable.svg": "1245",
	"./svg/thumb_up_blue.svg": "2e25",
	"./svg/timer.svg": "5d85",
	"./svg/topup-white-admin.svg": "6483",
	"./svg/topup-white.svg": "b865",
	"./svg/total-active-awb-hanging.svg": "6757",
	"./svg/total-bag-hanging.svg": "682f",
	"./svg/total-stt-hanging.svg": "fbfd",
	"./svg/train-booking-active.svg": "6393",
	"./svg/train-booking.svg": "8fad",
	"./svg/transfer-list-white.svg": "35ae",
	"./svg/transfer-list.svg": "92ff",
	"./svg/trash-red.svg": "5a7d",
	"./svg/trash-white.svg": "fca0",
	"./svg/trash.svg": "07fa",
	"./svg/trash_red.svg": "89fa",
	"./svg/truck-booking-active.svg": "8e1c",
	"./svg/truck-booking.svg": "7d9c",
	"./svg/truck-hanging.svg": "26db",
	"./svg/truck-pickup.svg": "7f1e",
	"./svg/truck-pup.svg": "4ea0",
	"./svg/union-edit.svg": "f0b9",
	"./svg/upload-gray.svg": "fc98",
	"./svg/upload-white.svg": "a8ad",
	"./svg/upload.svg": "f6b2e",
	"./svg/user-avatar-square.svg": "15d9",
	"./svg/user-avatar.svg": "9518",
	"./svg/user-management.svg": "f4f6",
	"./svg/vendor-dex-icon.svg": "4bfb",
	"./svg/wallet-cod-withdrawal.svg": "2368",
	"./svg/warning-circle.svg": "4265",
	"./svg/warning-embargo-detail.svg": "28ee",
	"./svg/warning-embargo.svg": "95a0",
	"./svg/warning-red.svg": "96d2",
	"./svg/warning-yellow.svg": "931d",
	"./svg/warning.svg": "ba7b",
	"./svg/whatsapp.svg": "9660",
	"./svg/white-check.svg": "a284",
	"./svg/withdraw-gray.svg": "904e",
	"./svg/withdraw-red.svg": "19d0",
	"./svg/x-circle-outline-dark-red.svg": "578a",
	"./svg/x-circle-outline-gray.svg": "9e2c",
	"./svg/x-circle-outline.svg": "c1b6",
	"./svg/x-circle-yellow.svg": "15e0",
	"./svg/x-circle.svg": "1910",
	"./svg/x-gray-24.svg": "68be",
	"./svg/x-gray.svg": "371f",
	"./svg/x-red.svg": "96e5",
	"./svg/x-white.svg": "5e42",
	"./svg/x.svg": "05d6",
	"./timeline/line.svg": "5d6b",
	"./timeline/round-active.svg": "f517",
	"./timeline/round-inactive.svg": "cc2a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "467c";